export default "__VITE_ASSET__VSb9uuZ1__"